export const isPC = () => {
  // const num = Number(vars.breakpointSm.slice(0, -2))
  return document?.body?.clientWidth >= 750
}
